import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('FORUM_CHILDRENS').plugin(axiosPlugin);

let fetchForumChildrensAction = redux.fetchActionGetOne();

export const fetchForumChildrens = (forumId, query = {}) => fetchForumChildrensAction(`/forums/${forumId}/childrens?${queryString.stringify(query)}`);
export const resetForumChildrens = () => redux.actions.reset();

export const forumChildrens = redux.reducer();